/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TimestampType } from '../../models/timestamp-type';

export interface GetServiceProviderBillingCsvGroupedBySiteTimestamp$Params {
  zip?: boolean;
  yearMonth: TimestampType;
}

export function getServiceProviderBillingCsvGroupedBySiteTimestamp(http: HttpClient, rootUrl: string, params: GetServiceProviderBillingCsvGroupedBySiteTimestamp$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, getServiceProviderBillingCsvGroupedBySiteTimestamp.PATH, 'get');
  if (params) {
    rb.query('zip', params.zip, {});
    rb.query('yearMonth', params.yearMonth, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/csv', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

getServiceProviderBillingCsvGroupedBySiteTimestamp.PATH = '/service-provider/billing/csv-grouped-by-site/timestamp';
